import { Action } from 'redux';

import { ResetIgnoreNextOrderUrlChange, SetIgnoreNextOrderUrlChange, SetOrder } from '../../app/actions/AppActionTypes';
import { isActionFactory } from '../../app/actions/isActionFactory';
import { IOrderClause } from '../../ts/ServerApi/types/IOrderClause';

export interface SetOrderAction extends Action {
  order: ReadonlyArray<IOrderClause>;
}

export function setOrderAction(order: ReadonlyArray<IOrderClause>): SetOrderAction {
  return {
    type: SetOrder,
    order: order
  };
}

export const isSetOrderAction = isActionFactory<SetOrderAction>(SetOrder);

export interface SetIgnoreNextOrderUrlChangeAction extends Action {}

export function setIgnoreNextOrderUrlChange(): SetIgnoreNextOrderUrlChangeAction {
  return {
    type: SetIgnoreNextOrderUrlChange,
  };
}

export const isSetIgnoreNextOrderUrlChange = isActionFactory<SetIgnoreNextOrderUrlChangeAction>(SetIgnoreNextOrderUrlChange);

export interface ResetIgnoreNextOrderUrlChangeAction extends Action {}

export function resetIgnoreNextOrderUrlChange(): ResetIgnoreNextOrderUrlChangeAction {
  return {
    type: ResetIgnoreNextOrderUrlChange,
  };
}

export const isResetIgnoreNextOrderUrlChange = isActionFactory<ResetIgnoreNextOrderUrlChangeAction>(ResetIgnoreNextOrderUrlChange);
